// src/utils/dateUtils.js

export const formatArgentineDate = (isoDate) => {
  if (!isoDate) return '-';

  // Normalize microseconds → to milliseconds
  const normalizedIso = isoDate.replace(/(\.\d{3})\d+/, '$1');

  const date = new Date(normalizedIso);

  return date.toLocaleString('es-AR', {
    timeZone: 'America/Argentina/Buenos_Aires',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false  // ✅ Force 24-hour format!
  });
};